import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppFile } from '../../../entities/AppFile';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { FileService } from '../../../services/file.service';
import { Task, TaskLevel } from '../../../entities/Task';
import { LoginService } from '../../../services/login.service';
import { NotificationService } from '../../../services/notification.service';
import { AppTaskCategory } from '../../../entities/AppTaskCategory';
import { SalesPersonService } from '../../../services/sales-person.service';
import { Responsible } from '../../../entities/SalesPerson';
import { SessionService } from '../../../services/session.service';
import { MaintenanceObjectPickerComponent } from '../maintenance-object-picker/maintenance-object-picker.component';
import { TranslationService } from 'app/services/translation.service';
import { ConverterService } from 'app/services/converter.service';

declare var $: any;

enum MobileNotificationSection {
  Details = 'details',
  Files = 'files'
}

@Component({
  selector: 'app-modal-notification',
  templateUrl: './modal-notification.component.html',
  styleUrls: ['./modal-notification.component.css']
})
export class ModalNotificationComponent implements OnInit {

  @ViewChild(MaintenanceObjectPickerComponent) maintenanceObjectPicker: MaintenanceObjectPickerComponent;

  _notificationToCreate: any = {};
  filesToDownload: AppFile[] = [];
  textFieldValue: string;
  isExpandedTextFieldAvailable: boolean;
  chosenProperty: string;
  filesToUpload: AppFile[] = [];
  currentFile: AppFile;
  loading: boolean;
  eksternalLoading: boolean;

  @ViewChild('myInput')
  fileChooserValue: ElementRef;
  dummyStart: any;
  dummyEnd: any;
  modal_dialog_custom_style: any = {};
  main_modal_body_custom_style: any = {};
  main_modal_body_custom_class: any = '';
  public modalTitle;
  public finishBtnText;
  public notificationAlreadyCreated: boolean;
  public startDatePickerOptions: IMyDpOptions;
  public endDatePickerOptions: IMyDpOptions;
  public AppTaskCategories: AppTaskCategory[];
  public salespersons: Responsible[];
  public companies: any[];
  public taskLevels = Object.keys(TaskLevel)
  public TaskLevels = TaskLevel
  public selectedCompany: string;
  createTaskIsDisabled: boolean;
  taskLevelDisabled: boolean;
  currentLanguage: string;
  public mobileNotificationSections = MobileNotificationSection;
  public currentMobileSection: MobileNotificationSection = MobileNotificationSection.Details;
  public isMobileLayout: boolean = false;
  @Output()
  createNotificationEmitter = new EventEmitter();

  @Output()
  updateNotificationEmitter = new EventEmitter();

  @Output()
  showAppTaskEmitter = new EventEmitter();
  public beginCreateTask: boolean;

  @Input('notification')
  set notification(result: any) {
    this._notificationToCreate = result;
    if (result.Maintenance_Object != null && result.Maintenance_Object != undefined) {
      this.getFiles(result);
    }

    if (this._notificationToCreate.No) {
      this.getAppTaskCategories();
      this.getSalesPersons();
    }

    this.handleOTSTaskLevel();
    this.currentMobileSection = MobileNotificationSection.Details;
    this.updateMobileLayout();
  }

  @Input('createTaskIsDisabledAndTrue')
  set createTaskIsDisabledAndTrue(value: boolean) {
    if (value !== undefined) {
      this._notificationToCreate.Create_Task = value;
      this.createTaskIsDisabled = value;
      this.toggleCreateTask(value);
    } else if (!this.isSelectedCompanyOTS) {
      this.createTaskIsDisabled = false;
      this._notificationToCreate.Create_Task = false;
    } else {
      this.createTaskIsDisabled = true;
      this._notificationToCreate.Create_Task = true;
    }
  }

  @Input('modalTitle')
  set ModalTitle(result: any) {
    this.modalTitle = result;
  }

  @Input('finishBtnText')
  set FinishBtnText(result: any) {
    this.finishBtnText = result;
  }

  @Input('notificationAlreadyCreated')
  set NotificationAlreadyCreated(result: any) {
    this.notificationAlreadyCreated = result;
  }

  @Input('eksternalLoading')
  set EksternalLoading(result: any) {
    this.eksternalLoading = result;
  }

  @Input('companies')
  set Companies(companies: any[]) {
    this.companies = companies;
  }

  constructor(
    private fileService: FileService, 
    private loginService: LoginService,
    private notificationService: NotificationService,
    private translationService: TranslationService,
    private salesPersonService: SalesPersonService, 
    private sessionService: SessionService,
    public convertService: ConverterService,
    ) {
    this.initCreation();
  }

  ngOnInit() {
    this.currentFile = new AppFile();

    this.updateMobileLayout();

    window.addEventListener('keydown', (ev) => {
      if (ev.code == 'Escape') {
        document.getElementById('closeModalNotificationBtn').click();
        this.reset();
      }
    });

    const activeLanguageSub = this.translationService.getLanguageSubject().subscribe(language => {
      this.currentLanguage = language;
     }, () => {}, () => {activeLanguageSub.unsubscribe()})
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateMobileLayout();
  }

  initCreation() {
    this._notificationToCreate = {
      Create_Task: this.isSelectedCompanyOTS ? true : false,
      Critical: false,
      Description: '',
      Created_By: this.loginService.getLoggedInUserID(),
      Task_Level: this.isSelectedCompanyOTS ? TaskLevel.OTS : TaskLevel.Intern,
    };

    if (this.createTaskIsDisabled) {
      this._notificationToCreate.Create_Task = true;
    }
    if (this.isSelectedCompanyOTS) {
      this._notificationToCreate.Task_Level = TaskLevel.OTS;
      this.toggleCreateTask(true);
    } else {
      this.getAppTaskCategories();
      this.getSalesPersons();
    }
    this.beginCreateTask = false;

    this.initCustomStyle();
  }

  initCustomStyle() {
    this.modal_dialog_custom_style = { 'width': '600px' };
    this.main_modal_body_custom_class = 'col-xs-12; col-sm-12; col-md-12; col-lg-12';

    if (this.notificationAlreadyCreated && this.filesToDownload.length > 0) {
      this.modal_dialog_custom_style = { 'width': '900px' };
      this.main_modal_body_custom_style = { 'border-bottom': '1px solid #e5e5e5', 'margin-bottom': '10px' };
      this.main_modal_body_custom_class = 'col-xs-8; col-sm-8; col-md-8; col-lg-8';
    }
  }

  public setMobileSection(section: MobileNotificationSection) {
    this.currentMobileSection = section;
  }

  public hasFiles(): boolean {
    return this.notificationAlreadyCreated && this.filesToDownload && this.filesToDownload.length > 0;
  }

  private updateMobileLayout() {
    this.isMobileLayout = window.innerWidth <= 768;
    if (!this.isMobileLayout) {
      return;
    }

    if (!this.hasFiles()) {
      this.currentMobileSection = MobileNotificationSection.Details;
    }
  }

  getAppTaskCategories() {
    this.notificationService.GetTaskCategories(this._notificationToCreate.Company_Reference).subscribe(result => {
      if (result.length > 0) {
        this.AppTaskCategories = result;
      }
    })
  }

  getSalesPersons() {
    this.salesPersonService.getAllSalesPersonsAsSalesPerson(this.selectedCompany).subscribe(result => {
      if (result.length > 0) {
        this.salespersons = result;
      }
    });
  }

  initDatapickers() {
    var baseStartDate = new Date();

    this.dummyStart = {
      date: {
        year: new Date(baseStartDate).getFullYear(),
        month: new Date(baseStartDate).getMonth() + 1,
        day: new Date(baseStartDate).getDate()
      }
    };

    this._notificationToCreate.Task_Date =
      new Date(
        baseStartDate.getFullYear(),
        baseStartDate.getMonth(),
        baseStartDate.getDate()
      );

    this.setOptionsData();

  }

  createNotification(notification) {
    if (!this._notificationToCreate.Create_Task) {
      this._notificationToCreate.Task_Date = null;
    }

    let responsible: Responsible = this.salespersons.find(resp => resp.Code == notification.Task_Responsible);
    let otsResponsible: Responsible = this.salespersons.find(otsResp => otsResp.Code == notification.Task_OTS_Responsible);

    if (responsible) {
      notification.Task_Responsible_Name = responsible.Name
    }

    if (otsResponsible) {
      notification.Task_OTS_Responsible_Name = otsResponsible.Name;
    }

    notification.Company_Reference = notification.Company_Reference !== '' ? notification.Company_Reference : this.sessionService.getSelectedCompany();
    this.reset();
    this.createNotificationEmitter.emit(notification);

  }

  get isSelectedCompanyOTS() {
    return this.sessionService.getCompanyType() === TaskLevel.OTS
  }

  get getSelectedCompany() {
    return this.sessionService.getSelectedCompany();
  }

  /**
   * Maintenance selection is ready when a company has been selected
   * in the case of non-OTS it's already ready. For OTS we must wait
   * for a company to be selected
   * @return true if a company has been selected.
   */
  get isMaintenanceSelectionReady(): boolean {
    if (this.isSelectedCompanyOTS) {
      return this._notificationToCreate.Company_Reference;
    }
    else {
      return true;
    }
  }

  onFileChange($event) {
    const files = $event.target.files;
    const filesToUpload = this.filesToUpload;
    const fcValue = this.fileChooserValue;
    const self = this;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const fileReader = new FileReader();
        let textFromFileLoaded;
        fileReader.onload = function (fileLoadedEvent: any) {
          textFromFileLoaded = fileLoadedEvent.target.result;

          const newFile = new AppFile();
          // base 64 encode
          newFile.File = btoa(textFromFileLoaded);
          newFile.Key = '{' + self._notificationToCreate.TaskGUID + '}';
          newFile.Type = 'App Task';
          newFile.FileName = file.name;

          let d = new Date();
          newFile.Created_DateTime = d.toDateString();
          filesToUpload.push(newFile);
          if (i === files.length - 1) {
            fcValue.nativeElement.value = '';
          }
        };
        fileReader.readAsBinaryString(file);
      }
    }
  }

  uploadFiles() {
    if (this.filesToUpload.length > 0) {
      this.loading = true;
      this.fileService.uploadFiles(this.filesToUpload, this.selectedCompany).subscribe(success => {
        this.loading = false;
        const length = this.filesToUpload.length;
        if (success.length === 0) {
          //this.snackBar.open(length - success.length + ' fil/filer eksisterer allerede. ', 'OK', {duration: 3000});
        }
        for (let j = 0; j < length; j++) {
          this.removeFile(this.filesToUpload[0]);
        }
        this.getFiles(this._notificationToCreate);
      });
    } else {
      const message = 'Vælg filer der skal uploades før du trykker upload'
      //this.snackBar.open(message, 'OK', {duration: 3000});
    }

  }

  removeFile(file: AppFile) {
    const index = this.filesToUpload.indexOf(file);
    if (index > -1) {
      this.filesToUpload.splice(index, 1);
    }
  }


  getFiles(task: Task) {
    if (task.Task_GUID != null) {
      this.fileService.getFilesByKey(task.Task_GUID, 'App Task', this.selectedCompany).subscribe(files => {
        this.filesToDownload = files;
        this.initCustomStyle();
        this.updateMobileLayout();
      });
    }
  }

  downloadFile(file) {
    this.fileService.downloadFile(file.No).subscribe(blob => {
      const fileUrl = URL.createObjectURL(blob);
      // for IE 10+
      const nav = window.navigator as any;

      if (nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, file.FileName);
      } else {
        const element = document.createElement('a');
        element.href = fileUrl;
        element.setAttribute('download', file.FileName);
        element.setAttribute('target', '_blank');
        element.dispatchEvent(new MouseEvent('click'));
        URL.revokeObjectURL(fileUrl);
      }
    });
  }


  setOptionsData() {
    this.startDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{
        begin: {
          year: new Date(this._notificationToCreate.end).getFullYear(),
          month: new Date(this._notificationToCreate.end).getMonth() + 1,
          day: new Date(this._notificationToCreate.end).getDate() + 1
        }, end: { year: 2055, month: 11, day: 20 }
      }],
    };
    this.endDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{
        begin: { year: 1980, month: 11, day: 20 },
        end: {
          year: new Date(this._notificationToCreate.start).getFullYear(),
          month: new Date(this._notificationToCreate.start).getMonth() + 1,
          day: new Date(this._notificationToCreate.start).getDate() - 1
        }
      }],
    };
  }

  setTaskDate(event: IMyDateModel) {
    this._notificationToCreate.Task_Date = event.jsdate.toDateString();
  }

  setEndDate(event: IMyDateModel) {
    this._notificationToCreate.end = event.jsdate.toDateString();

    this.setOptionsData();
  }

  StringIsNullOrEmpty(string: string) {
    return !(typeof string != 'undefined' && string);
  }


  toggleCreateTask(b: boolean) {
    this.beginCreateTask = b;

    if (b) {
      this.initDatapickers();
    } else {
      this._notificationToCreate.Task_Date = null;
    }
  }

  showAppTask() {
    this.showAppTaskEmitter.emit(this._notificationToCreate.Task_GUID)
  }

  setCreateAppTaskAndSave() {
    this.beginCreateTask = false;
    this._notificationToCreate.Create_Task = true;
    this.updateNotificationEmitter.emit(this._notificationToCreate);
  }

  getNameWithoutType(fileName: String): string {
    var splitName = fileName.split('.');

    if (splitName.length < 2) {
      return splitName[0];
    }

    var subArray = splitName.slice(0, (splitName.length - 1)).join('.');

    return subArray;
  }

  getFileType(fileName: String): string {
    var splitName = fileName.split('.');
    return splitName[splitName.length - 1];
  }

  setDefaultTaskDate(value) {
    if (value.checked) {
      this.initDatapickers();
    } else {
      this._notificationToCreate.Task_Date = null;
    }

  }

  setMaintenanceObject(result: any) {
    if (result != null) {
      this._notificationToCreate.Maintenance_Object = result.No;
    }
  }

  openExpandedTextField(propertyName: string, elementId: string) {
    this.isExpandedTextFieldAvailable = true;
    setTimeout(() => {
      document.getElementById(elementId)!.blur();
      $('#expandedTextFieldModal').on('hidden.bs.modal', () => {
        this.textFieldValue = '';
      })
      this.chosenProperty = propertyName;
      this.textFieldValue = this._notificationToCreate[propertyName];
      $('#expandedTextFieldModal').modal('show');
    }, 5);
  }

  closeExpandedTextField(value: string) {
    value !== undefined
      ? this._notificationToCreate[this.chosenProperty] = value
      : this.textFieldValue = '';

    $('#expandedTextFieldModal').modal('hide');
    setTimeout(() => {
      this.isExpandedTextFieldAvailable = false;
    }, 5);
  }

  selectedCompanyChanged() {
    this.getAppTaskCategories();
    this.getSalesPersons();
    this._notificationToCreate.Maintenance_Object = '';
  }

  selectedTaskLevelChanged() {
    this.initDatapickers()
    this.handleOTSTaskLevel();
  }

  private handleOTSTaskLevel() {
    if (this._notificationToCreate.Task_Level === TaskLevel.OTS) {
      this._notificationToCreate.Create_Task = true;
      this.createTaskIsDisabled = true;
    } else {
      this.createTaskIsDisabled = false;
    }
  }

  public reset() {
    this.initCreation();
    this._notificationToCreate.Create_Task = this.isSelectedCompanyOTS ? true : false;
    this.createTaskIsDisabled = this.isSelectedCompanyOTS ? true : false;
    this.currentMobileSection = MobileNotificationSection.Details;

    if (this.maintenanceObjectPicker)
      this.maintenanceObjectPicker.reset();
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-notification/modal-notification.component.ts